import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 22,
    width: 22
  },
  avatarBorder: {
    border: 'solid 2px white'
  },
  marginLeft: {
    zIndex: 1,
    marginLeft: '-8px'
  }
}))

export default useStyles
